module.exports = __webpack_public_path__ + "431eefe6f8cdfccb7845625a42a68e66.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/landing/sync/screen/desktop.png
// module id = 1827
// module chunks = 1